module.exports = __webpack_public_path__ + "static/img/A121.97a28cee.jpg";